import useKeyValue from "../../../../client-storage/hooks/useKeyValue.hook.js";
import { useEnvironmentContext } from "../../../../components/providers/Environment/index.js";
export const useSearchResults = ({ amountResults = 5, authUniqueId = "noUserId" } = {}) => {
    // Get the current appName and default to sdb
    const { appName = "sdb" } = useEnvironmentContext();
    // State
    const [previousSearchQueries, setPreviousSearchQueries] = useKeyValue(appName, authUniqueId, "previousSearchResults", []);
    return {
        setQuery: (newQuery) => {
            const newQueries = previousSearchQueries.filter((query) => query !== newQuery);
            newQueries.push(newQuery);
            if (newQueries.length <= amountResults) {
                setPreviousSearchQueries(newQueries);
            }
            else {
                setPreviousSearchQueries(newQueries.slice(-amountResults));
            }
        },
        queries: previousSearchQueries,
    };
};
export default useSearchResults;
